import style from './GenericForm.module.css';
import styled from 'styled-components';

const Formulario = styled.form`
    display: flex;
    flex-direction: column;
    width: ${props => props.width || '100%'};
    margin: 0 auto;
`

const GenericForm = ({ children, onSubmit, tamanho = '80' }) => {

    const handleSubmit = (e) => {

        e.preventDefault();
        onSubmit();

    }

    return (
        <Formulario width={ `${ tamanho }%` } onSubmit={handleSubmit} >
            {children}
            <input className={style.saveBtn} type='submit' value='SALVAR' />
        </Formulario>
    )

}

export default GenericForm;